module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_widthsMinList.f3b53210.bin";